import type { ReactNode } from 'react';
import { Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useTheme } from '../../hooks/useTheme';

/** Headerless auth pages need a safe viewport on edge-to-edge Android. */
export function AuthScreenSafeArea({ children }: { children: ReactNode }) {
  const { theme } = useTheme();
  if (Platform.OS !== 'android') return children;

  return (
    <SafeAreaView edges={['top', 'bottom', 'left', 'right']} style={{ flex: 1, backgroundColor: theme.background }}>
      {children}
    </SafeAreaView>
  );
}
